import React from 'react'
import styles from "../EnhancedDepth/EnhancedDepth.module.css"

const EnhancedDepth = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.imgdiv}>
                <img src='Images/Defth-of-field.png' alt='illustration of the extended depth of field created by the Eclipsys light field' loading="lazy" decoding="async" />
            </div>
            <div className={styles.DividerDiv}>
                <img src='Images/Divider-Graphic.webp' alt='Divider-Graphic' loading="lazy" decoding="async" />
            </div>
        </div>
    )
}

export default EnhancedDepth
